import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

/**
 * There is a detailed Windows path spec [1], however I'm not following that and
 * am instead just using a sample from RegExLib [2], which also supports UNC
 * paths [3].
 *
 * I'm intentionally choosing not to allow relative paths such as `..\foo`.
 *
 * [1]: https://docs.microsoft.com/en-us/windows/win32/fileio/naming-a-file
 * [2]: https://regexlib.com/REDetails.aspx?regexp_id=1623
 * [3]: https://bit.ly/2FCQVfd
 */
const windowsPathRegex = new RegExp(/^(([a-zA-Z]\:)|(\\))(\\{1}|((\\{1})[^\\]([^/:*?<>"|]*))+)$/i)

/**
 * This regular expression was taken from Stake Overflow [1]
 *
 * [1]: https://stackoverflow.com/a/28989719/13253703
 */
const nixPathRegex = new RegExp(/^(\/[^/ ]*)+\/?$/)

export const invalidFolderPathMessage = 'You must enter a valid folder path.'
export const isValidFolderPath: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value: string = control.value
  return isWindowsPath(value) || isNixPath(value) ? null : { invalidFolderPath: invalidFolderPathMessage }
}

function isWindowsPath(path: string): boolean {
  return windowsPathRegex.test(path)
}

function isNixPath(path: string): boolean {
  return nixPathRegex.test(path)
}
